// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Button } from 'grommet';

const RedButton = styled(Button)`
    border: none;
    background: #ffb2b2;
    color: #990000;
    border: none;
    &:hover {
        box-shadow: none;
    }
    height: 32px;
`;

type Props = {
    children?: React.Node,
};

const RedButtonComponent = (props: Props) => {
    const { children, ...rest } = props;
    return (
        <RedButton
            hoverIndicator={{ color: '#ff6666' }}
            {...rest}
        >
            {children}
        </RedButton>
    );
};

RedButtonComponent.defaultProps = {
    children: undefined,
};

export default RedButtonComponent;
